import * as types from './types';

const initialState = {
  offers: [],
  isFetchingOffers: false,
  isOfferDownloading: false,
  selectedOffer: undefined,
  currentPage: 0,
  total: 0,
  pageSize: 25,
  appliedFilters: {},
  counties: [],
  markets: [],
  pendingDealSubmissionsCounter: 0,
  pendingPreDealsCounter: 0,
  selectedOfferForContact: undefined,
};

export default (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case types.SET_OFFERS:
    case types.SET_IS_FETCHING_OFFERS:
    case types.SET_IS_DOWNLOAD_OFFERS:
    case types.SET_OFFER:
    case types.SET_CURRENT_PAGE:
    case types.SET_PAGE_SIZE:
    case types.SET_APPLIED_FILTERS:
    case types.SET_COUNTIES_AND_MARKETS:
    case types.SET_IS_FETCHING_COUNTIES_AND_MARKETS:
    case types.SET_PENDING_ACTIONS:
    case types.SET_SELECTED_OFFER_FOR_CONTACT:
      return {
        ...state,
        ...payload,
      };
    default:
      return state;
  }
};
